import { render, staticRenderFns } from "./ONavDashboardMenu.vue?vue&type=template&id=f9291a68&scoped=true&"
import script from "./ONavDashboardMenu.vue?vue&type=script&lang=js&"
export * from "./ONavDashboardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9291a68",
  null
  
)

export default component.exports